import { render, staticRenderFns } from "./homeTitle.vue?vue&type=template&id=3a201278&scoped=true"
import script from "./homeTitle.vue?vue&type=script&lang=js"
export * from "./homeTitle.vue?vue&type=script&lang=js"
import style0 from "./homeTitle.vue?vue&type=style&index=0&id=3a201278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a201278",
  null
  
)

export default component.exports